import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {INPUT_TYPE, ResponseCode} from "@app/constants/Common";
import CreatePerson from "@pages/candidate/userinput/CreatePerson";
import UploadCV from "@pages/candidate/userinput/UploadCV";
import {requestCheckPersonInJobPipeline} from "@app/services/JobPipelineService";
import {alertMessage, Messages, showMessage} from "@app/constants/Messages";

const PipelineRefereeInputModal = (props) => {
    const [hideColumns, setHideColumns] = useState({});
    const [pipeLine, setPipeLine] = useState({});
    const [confirmInput, setConfirmInput] = useState({});
    const [isFullScreen, setFullScreen] = useState(false);
    const [newPersonId, setNewPersonId] = useState("");
    const [showAddPersonToPipelineButton, setShowAddPersonToPipelineButton] = useState(false);

    const [isLoading, setIsLoading] = useState(false)
    const {isShow, jobPipeline, onClose, onNext, showBtnAddPipeline} = props

    useEffect(() => {
        const jbPipeline = {...jobPipeline}
        setPipeLine(jbPipeline)
        const refereeConfirmInput = jbPipeline.confirmInputReferee
        if (refereeConfirmInput) {
            refereeConfirmInput.job_pipeline_id = jbPipeline.id
            setConfirmInput(refereeConfirmInput)
        }
    }, [jobPipeline]);

    useEffect(() => {
        setShowAddPersonToPipelineButton(showBtnAddPipeline)
    }, [showBtnAddPipeline]);

    const nextAddPersonInPipeline = () => {
        if (newPersonId) {
            onNext(newPersonId)
        }
    }

    const onFinishCheckExists = (newCandidateId) => {
        setNewPersonId(newCandidateId)
        setFullScreen(true)
        const body = {job_id: pipeLine.job_id, candidate_id: newCandidateId, job_pipeline_id: pipeLine.id}
        requestCheckPersonInJobPipeline(body).then((res) => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                const resContent = res.content
                // Trường hợp person mới nhập đã đc add vào 1 pipeline nào đó của job này rồi.
                if (resContent.person_in_pipe_line) {
                    showMessage(Messages.editRefereeOfPipelineSuccess + ` Referee = ${newCandidateId}`)
                } else {
                    onNext(newCandidateId)
                    // setShowAddPersonToPipelineButton(true)
                }
            } else {
                alertMessage(res.sts_code, true, true)
            }

        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    return (
        <>
            <Modal show={isShow}
                   fullscreen={isFullScreen}
                   size={'xl'}
                   className={"PipelineRefereeInputModal"}
                   onHide={onClose}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Nhập thông tin referee - Job pipeline: {pipeLine.id}</Modal.Title>
                    <div className={"card-tools"}>
                        {newPersonId && showAddPersonToPipelineButton &&
                        <Button variant='success' className={'mr-3'} onClick={nextAddPersonInPipeline}>
                            Add Person này vào Pipeline
                        </Button>
                        }
                        <Button variant='secondary' onClick={onClose}>
                            Close
                        </Button>
                    </div>

                </Modal.Header>
                <Modal.Body style={{height: '100vh'}}>
                    {confirmInput.inputType === INPUT_TYPE.INPUT_PART && (
                        <CreatePerson refererInfo={confirmInput || {}} onFinishCheckExists={(candidateId) => onFinishCheckExists(candidateId)}/>
                    )}
                    {confirmInput.inputType === INPUT_TYPE.UPLOAD_CV && (
                        <UploadCV refererInfo={confirmInput || {}} onFinishCheckExists={(candidateId) => onFinishCheckExists(candidateId)}/>
                    )}
                </Modal.Body>
                {/*<Modal.Footer>*/}
                {/*    <Button type='button'*/}
                {/*            className='btn btn-primary'*/}
                {/*            isLoading={isLoading}*/}
                {/*            disabled={*/}
                {/*                isLoading*/}
                {/*            }*/}
                {/*            onClick={() => {*/}
                {/*                onSave(hideColumns)*/}
                {/*            }}*/}
                {/*            >*/}
                {/*        <i className='fas fa-save mr-2'/>*/}
                {/*        Save*/}
                {/*    </Button>*/}
                {/*</Modal.Footer>*/}
            </Modal>
        </>
    )
}

export default PipelineRefereeInputModal;
